module.exports = __webpack_public_path__ + "teqbahn-assets/media/10.f01d6fc7.jpg";